module.exports = __webpack_public_path__ + "static/media/eng_d_2506.0960b816.vtt";